import React, { useState, useEffect } from "react";
import { Select, MenuItem, FormControl } from "@mui/material";

function MarkerSizeSelect(props) {
  const { updateMarkerSize, dist, defaultMarkerSize = 6 } = props;
  const [markerSize, setMarkerSize] = useState(defaultMarkerSize);

  useEffect(() => {
    setMarkerSize(defaultMarkerSize);
  }, [defaultMarkerSize]);

  const handleChange = (event) => {
    const newSize = parseInt(event.target.value, 10);
    setMarkerSize(newSize);
    updateMarkerSize(newSize, dist);
  };

  const sizeOptions = [4, 6, 8, 10, 12, 14, 16];

  return (
    <FormControl
      size="small"
      variant="standard"
      style={{ width: 35, justifySelf: "center" }}
    >
      <Select
        value={markerSize}
        onChange={handleChange}
        label="Marker Size"
        style={{ padding: 0, height: "20px", width: "35px" }}
        renderValue={(value) => {
          return (
            <span
              style={{
                display: "inline-block",
                width: `${value}px`,
                height: `${value}px`,
                borderRadius: "50%",
                backgroundColor: "#000",
                verticalAlign: "middle",
              }}
            />
          );
        }}
      >
        {sizeOptions.map((size) => (
          <MenuItem key={size} value={size}>
            <span
              style={{
                display: "inline-block",
                width: `${size}px`,
                height: `${size}px`,
                borderRadius: "50%",
                backgroundColor: "#000",
                verticalAlign: "middle",
              }}
            />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default MarkerSizeSelect;

